import { toLowerCaseFirstLetter } from '~/utils/tool';
import type { ChatMessageDto, ChatNoteDto, ChatNoteAuthor, ChatNoteKind, EntityType, PropertyManagerDto } from './Api';

export interface ChatMessagesPage {
  messages: ChatMessageDto[];
  notes: ChatNoteDto[];
  propertyManagers: PropertyManagerDto[];
  totalCount: number;
}

export interface ChatHumanEngagementChange {
  chatId: string;
  requested: boolean;
  requestedAt?: string | null;
}

export interface ChatAssignmentChange {
  chatId: string;
  assignedPropertyManagerId: string | null;
  assignedByPropertyManagerId: string | null;
  assignedAt?: string | null;
}

const lowerFirst = (value?: string | null): string | null => (value ? toLowerCaseFirstLetter(value) : null);

export const normalizeChatNote = (raw: Record<string, unknown>): ChatNoteDto => {
  const referencedEntityType = lowerFirst(raw.referencedEntityType as string | null | undefined);
  return {
    ...(raw as unknown as ChatNoteDto),
    kind: (lowerFirst(raw.kind as string) ?? 'note') as ChatNoteKind,
    author: (lowerFirst(raw.author as string) ?? 'system') as ChatNoteAuthor,
    referencedEntityType: (referencedEntityType ?? undefined) as EntityType | undefined,
  };
};
